var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2336_70374)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2336_70374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V60H90V0H0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2336_70374)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V60H90V0H0Z",
    fill: "#012169"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L90 60L0 0ZM90 0L0 60L90 0Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9375 30L-2.0127 5.36656L2.01223 -5.36656L44.9998 23.2918L87.9873 -5.36656L92.0122 5.36656L55.0621 30L92.0122 54.6334L87.9873 65.3666L44.9998 36.7082L2.01223 65.3666L-2.0127 54.6334L34.9375 30Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2336_70374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 60
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30H90V60L45 30ZM45 30V60H0L45 30ZM45 30H0V0L45 30ZM45 30V0H90L45 30Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2336_70374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L90 60L0 0ZM90 0L0 60L90 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2916 30L-1.3418 3.5777L1.34148 -3.57771L44.9998 25.5279L88.6582 -3.57771L91.3415 3.5777L51.7081 30L91.3415 56.4223L88.6582 63.5777L44.9998 34.4721L1.34148 63.5777L-1.3418 56.4223L38.2916 30Z",
    fill: "#C8102E"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 0V60V0ZM0 30H90H0Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 20V0H52.5V20H90V40H52.5V60H37.5V40H0V20H37.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45 0V60V0ZM0 30H90H0Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5 24V0H49.5V24H90V36H49.5V60H40.5V36H0V24H40.5Z",
    fill: "#C8102E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2336_70374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/EN.b75741bba1ec3659979d43ee21d9c618.svg";
export { ForwardRef as ReactComponent };